export const saveOrderToLocalStorage = (
  actionToExcute,
  cart,
  itemToExecute,
) => {
  let updatedItems;
  switch (actionToExcute) {
    case "AddItem":
      const existingItems = cart || [];
      updatedItems = existingItems.some(
        (item) => item.productId === itemToExecute.productId,
      )
        ? existingItems.map((item) =>
            item.productId === itemToExecute.productId
              ? { ...item, ...itemToExecute }
              : item,
          )
        : [...existingItems, itemToExecute];
      break;
    case "UpdateQuantity":
      updatedItems = cart.map((item) =>
        item.productId === itemToExecute.productId
          ? { ...item, quantity: itemToExecute.quantity }
          : item,
      );
      break;
    case "RemoveItem":
      updatedItems = cart.filter(
        (item) => item.productId !== itemToExecute.productId,
      );
      break;
    default:
      break;
  }

  localStorage.setItem("currentOrder", JSON.stringify(updatedItems));
};

export const getDataFromLocalStorage = (key) => {
  const data = localStorage.getItem(key);
  return data ? JSON.parse(data) : null;
};
